import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { signinRedirectCallback } from '../../services/authService';
import EpPageLoading from '../../components/EpPageLoading';

function SigninOidcPage() {
  const history = useHistory();

  useEffect(() => {
    async function signinAsync() {
      await signinRedirectCallback();
      history.push('/');
    }
    signinAsync();
  }, [history]);

  return <EpPageLoading />;
}

export default SigninOidcPage;
